function getGtmSessionIdFixed(measurementId: string) {
  const name = '_ga_' + measurementId;
  const match = document.cookie.match(new RegExp(name + '=GS\\d\\.\\d\\.(s?(\\d+))'));
  
  if (match && match[2]) {
    // match[2] 会精准匹配到 s 之后的纯数字部分
    return match[2];
  }
  return null;
}

// 获取GA instance Id 和 Session Id；web没有instanceId返回clientId
export const getGaInfo = () => {
  if (typeof window === "undefined") {
    return { gaInstanceId: undefined, sessionId: undefined, clientId: "" };
  }
  const appDeviceInfo = (window as any).__APP_DEVICE_INFO__;
  if (appDeviceInfo) {
    return {
      gaInstanceId: appDeviceInfo.gaInstanceId,
      sessionId: appDeviceInfo.sessionId,
    };
  }
  const clientId = document.cookie.match(/_ga=GA1\.\d+\.(\d+\.\d+)/)?.[1] || "";
  const GA_ID = (window as any).GA_ID;
  const sessionId = getGtmSessionIdFixed(GA_ID?.replace?.("G-", "")) || "";

  return {
    clientId: clientId,
    sessionId: sessionId,
  };
};

export type GaInfo = ReturnType<typeof getGaInfo>;

/**
 * 上报用 GA 信息：优先使用 getGaInfo()；
 * 若宿主通过 window.__requestGAInfoFromNative 注入了“向原生请求”的实现，
 * 且在 App 内缺 gaInstanceId/sessionId 时会调用并合并结果（用于弥补注入失败或延迟）。
 */
export async function getGaInfoForReporting(): Promise<GaInfo> {
  const gaInfo = getGaInfo();
  if (typeof window === "undefined") {
    return gaInfo;
  }
  const requestFromNative = (window as any).__requestGAInfoFromNative as
    | (() => Promise<{ gaInstanceId?: string; sessionId?: string }>)
    | undefined;
  const needFallback =
    typeof requestFromNative === "function" &&
    (!gaInfo.gaInstanceId || !gaInfo.sessionId);
  if (needFallback) {
    try {
      const res = await requestFromNative!();
      if (res?.gaInstanceId) {
        gaInfo.gaInstanceId = res.gaInstanceId;
      }
      if (res?.sessionId) {
        gaInfo.sessionId = res.sessionId;
      }
    } catch {
      // 超时或旧壳未实现，使用当前 getGaInfo() 结果
    }
  }
  return gaInfo;
}